import { profileApi } from '@/api/profile.api'

export const profileService = (function () {
  'use strict'

  // private Methods
  function setIdsToTree (currentString, listOfchildrens) {
    listOfchildrens.forEach(children => {
      if (currentString) {
        children.id = currentString + '.' + children.name
      } else {
        children.id = children.name
      }
      if (children.children && children.children.length > 0) {
        setIdsToTree(children.id, children.children)
      }
    })
  }

  // public Methods
  function initilizeProfileToTreeView (tree) {
    setIdsToTree(null, tree)
  }

  function makeTreeByIds (elements, identifiers) {
    if (identifiers.length > 0) {
      let object = elements.find((element) => { return element.name === identifiers[0] })
      if (!object) {
        object = { name: identifiers[0] }
        elements.push(object)
      }
      if (identifiers.length > 1) {
        if (!Array.isArray(object.children)) {
          object.children = []
        }
        identifiers.shift()
        makeTreeByIds(object.children, identifiers)
      }
    }
  }

  function markProfilesByTree (list, string, result) {
    list.forEach(element => {
      let name = ''
      if (!string) {
        name = element.name
      } else {
        name = string + '.' + element.name
      }
      if (Array.isArray(element.children)) {
        markProfilesByTree(element.children, name, result)
      } else {
        result.push(name)
      }
    })
  }

  /**
   * Datos para la tabla del ABM
   * TO DO: implementar la paginación
   */
  async function findAll (enterpriseIds) {
    try {
      if (enterpriseIds && enterpriseIds.length > 0) {
        const response = await profileApi.getProfiles(enterpriseIds)
        return response.data
      } else {
        return []
      }
    } catch (exception) {
      console.log(exception)
      return {
        data: [],
        headers: []
      }
    }
  }

  /**
   * Para eliminar un perfil
   */
  async function deleteOne(id) {
    const response = await profileApi.deleteProfileById(id)
    return response.data
  }

  /**
   * Devuelve true si el nombre ya existe para un perfil de la collection
   * @param {*} name
   */
  async function validateName(name) {
    try {
      if (name) {
        const response = await profileApi.validateName(name)
        return response.data
      } else {
        return false
      }
    } catch (exception) {
      console.log(exception)
      return false
    }
  }

  /**
   * Crea un nuevo perfil
   * @param {*} profile
   */
  async function create(profile) {
    const response = await profileApi.createProfile(profile)
    return response && response.data ? response.data : null
  }

  /**
   * Actualiza un perfil
   * @param {*} profile
   */
  async function update(profile) {
    const response = await profileApi.updateProfile(profile)
    return response && response.data ? response.data : null
  }

  /**
   * Esquema del perfil
   */
  async function getProfileSchema () {
    try {
      const response = await profileApi.getProfileSchema()
      return response.data
    } catch (exception) {
      console.log(exception)
      return []
    }
  }

  /**
   * Obtiene un perfil de la collection a partir de su id
   * @param {*} id 
   */
  async function getProfileById (id) {
    try {
      const response = await profileApi.getProfileById(id)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
  }

  /**
   * Obtiene un perfil de la collection junto con un arreglo de usuarios asignados
   * @param {*} id 
   */
  async function getProfileAndUsersById (id) {
    try {
      const response = await profileApi.getProfileAndUsersById(id)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
  }

  /**
   * Elimina un perfil y reasigna a los usuarios
   * @param {*} deleteId
   * @param {*} newProfileId
   * @param {*} userIds
   */
  async function reasssignAndDeleteProfile (deleteId, newProfileId, userIds) {
    try {
      await profileApi.deleteProfileById(deleteId)
      const response = await profileApi.assignUsersToProfile(newProfileId, userIds)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
  }

  /**
   * Para seleccionar todos los modulos del árbol en el diálogo del ABM
   * @param {*} items
   * @param {*} result
   */
  function selectAll (items, result) {
    items.forEach(item => {
      if (item.children && item.children.length > 0) {
        selectAll(item.children, result)
      } else {
        result.push(item.key)
      }
    })
  }

  /**
   * Obtener el arreglo de perfiles para el selector en el ABM de usuarios
   * @param {*} enterpriseIds
   */
  async function getAllForSelectorUserABM(enterpriseIds) {
    try {
      const response = await profileApi.getAllForSelectorUserABM(enterpriseIds)
      return response.data
    } catch (exception) {
      console.log(exception)
      return []
    }
  }

  return {
    initilizeProfileToTreeView,
    makeTreeByIds,
    markProfilesByTree,
    findAll,
    deleteOne,
    validateName,
    create,
    update,
    getProfileSchema,
    getProfileById,
    getProfileAndUsersById,
    reasssignAndDeleteProfile,
    selectAll,
    getAllForSelectorUserABM
  }
})()
